import axios from "axios";


// Registration API
export function createRegistration(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}raceform`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}


export async function createChambaRegistration(payload) {
  try {
    const formData = new FormData();
    console.log(payload);

    Object.keys(payload).forEach((key) => {
   
      if (key === "declaration") return;

      const value = payload[key];

     
      if (key === "id_proof" && value instanceof File) {
        formData.append("files", value, value.name);
      }

      
      else if (value === null || value === undefined) {
        formData.append(key, "");
      }
     
      else {
        formData.append(key, value.toString());
      }
    });

    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}chamba/race`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("❌ Error in createChambaRegistration:", error);
    throw error.response?.data || error;
  }
}





// Create Payment Session
export function createPaymentSession(phone, amount) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}race/payment/${encodeURIComponent(phone)}/${amount}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

// Get Payment Status
export function getPaymentStatus(linkId) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}race/status/payment/${encodeURIComponent(linkId)}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}
